import { Article, ProductGroup } from "@tm/models"

export type RecommendedArticleIn = {
    supplierArticleNo: string
    supplierId: number
    productGroupId?: number
    isSelected?: boolean
}

export type GetRecommendedArticlesRequest = {
    modelId?: number
    maxCount?: number
    articles: Array<RecommendedArticleIn>
}

export enum CrossSellingModalToOpen {
    PKW = "PKW",
    UNI = "UNI",
}

export type CrossSellingArticleListToOpen = keyof typeof CrossSellingModalToOpen

export type CrossSellingProductGroup = ProductGroup & {
    articleListToOpen: CrossSellingArticleListToOpen
}

export type GetRecommendedArticlesResponse = {
    articles: Array<Article>
    productGroups: CrossSellingProductGroup[]
    recommendedProductGroups: CrossSellingProductGroup[]
}
